import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import router from '@/../src/router/index'
import axios from 'axios'

let state = {
  SIQA_Catalogos_003TiposDeSentidoDeSentencia: []
}

let getters = {
  Get_SIQA_Catalogos_003TipoDeSentidoDeSentencia: state => {
    return state.SIQA_Catalogos_003TiposDeSentidoDeSentencia;
  }
}

let mutations = {
  M_SIQA_Catalogos_003TipoDeSentidoDeSentencia(state, data) {
    state.SIQA_Catalogos_003TiposDeSentidoDeSentencia[data.llave] = data.valor;
  }
}

let actions = {
  A_SIQA_Catalogo_Establecer003TipoDeSentidoDeSentencia: ({ commit }, data) => {
    commit('M_SIQA_Catalogos_003TipoDeSentidoDeSentencia', data);
  }
}

const SIQA = {
  Getters: getters,
  State: state,
  Mutations: mutations,
  Actions: actions
}
export default SIQA;



// WEBPACK FOOTER //
// ./src/store/SIQA.js